import { t } from '@lingui/core/macro';
import { UserPlusIcon } from 'lucide-react';
import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';
import { CustomStepper } from '@duke-hq/ui/components/StepWizard/CustomStepper';
import { useStep } from '@duke-hq/ui/components/StepWizard/useStep';
import {
  getQuickReferralStepTitles,
  getQuickReferralStepsContent,
} from '../../constants/stepperForm';
import { Box, Stack, VStack } from '@chakra-ui/react';
import { useSnapshot } from 'valtio';
import { quickReferralModalState } from '../../tenantState/QuickReferralState';
import { testIds } from './testIds';

function ModalContent() {
  const stepTitles = getQuickReferralStepTitles();
  const { currentStep, setStep, goToNextStep, goToPrevStep } = useStep({
    maxStep: stepTitles.length - 1,
    initialStep: 0,
  });
  const stepContents = getQuickReferralStepsContent({
    goToNextStep,
    goToPrevStep,
    setStep,
  });

  return (
    <VStack w="full" h="full" justify="start" gap="16px" data-testid={testIds.multiStepForm}>
      <Box w="full">
        <Stack spacing="0" direction={{ base: 'column', md: 'row' }}>
          {stepTitles.map((step, stepIndex) => (
            <CustomStepper
              key={step}
              cursor="pointer"
              onClick={() => {
                if (currentStep > stepIndex) {
                  setStep(stepIndex);
                }
              }}
              title={step}
              isActive={currentStep === stepIndex}
              isCompleted={currentStep > stepIndex}
              isFirstStep={stepIndex === 0}
              isLastStep={stepTitles.length === stepIndex + 1}
            />
          ))}
        </Stack>
      </Box>
      <Box w="full" h="full">
        {stepContents[currentStep]}
      </Box>
    </VStack>
  );
}

export default function QuickReferralModal() {
  const quickReferralModalSnap = useSnapshot(quickReferralModalState);
  const { openModal, closeModal } = quickReferralModalState;

  return (
    <FormModalWrapper
      modalOpenButtonText={t`Create referral`}
      modalOpenButtonLeftIcon={UserPlusIcon}
      modalContent={<ModalContent />}
      isOpen={quickReferralModalSnap.isModalOpen}
      onClose={closeModal}
      onOpen={openModal}
      modalContentHeight="700px"
      modalOpenButtonTestId={testIds.createReferral}
    />
  );
}
